/**
 * Copyright (C) Boost commerce
 * This file is part of commercial Boost commerce projects
 *
 * This file can not be copied and/or distributed without the express
 * permission of Boost commerce
 *
 * Created on Mon Aug 01 2024 14:16:39
 */
// @flow

import type { Action } from './store.type';

export const GET_CSAT_RATING_REQUEST = 'GET_CSAT_RATING_REQUEST';
type GET_CSAT_RATING_REQUEST_TYPE = 'GET_CSAT_RATING_REQUEST';
export const GET_CSAT_RATING_SUCCESS = 'GET_CSAT_RATING_SUCCESS';
type GET_CSAT_RATING_SUCCESS_TYPE = 'GET_CSAT_RATING_SUCCESS';
export const GET_CSAT_RATING_FAILURE = 'GET_CSAT_RATING_FAILURE';
type GET_CSAT_RATING_FAILURE_TYPE = 'GET_CSAT_RATING_FAILURE';

export const UPDATE_CSAT_RATING_REQUEST = 'UPDATE_CSAT_RATING_REQUEST';
type UPDATE_CSAT_RATING_REQUEST_TYPE = 'UPDATE_CSAT_RATING_REQUEST';
export const UPDATE_CSAT_RATING_SUCCESS = 'UPDATE_CSAT_RATING_SUCCESS';
type UPDATE_CSAT_RATING_SUCCESS_TYPE = 'UPDATE_CSAT_RATING_SUCCESS';
export const UPDATE_CSAT_RATING_FAILURE = 'UPDATE_CSAT_RATING_FAILURE';
type UPDATE_CSAT_RATING_FAILURE_TYPE = 'UPDATE_CSAT_RATING_FAILURE';

type UpdateCSATRatingRequestAction = Action<UPDATE_CSAT_RATING_REQUEST_TYPE, any>;
type UpdateCSATRatingSuccessAction = Action<UPDATE_CSAT_RATING_SUCCESS_TYPE, any>;
type UpdateCSATRatingFailureAction = Action<UPDATE_CSAT_RATING_FAILURE_TYPE, any>;

type GetCSATRatingRequestAction = Action<GET_CSAT_RATING_REQUEST_TYPE, null>;
type GetCSATRatingSuccessAction = Action<
  GET_CSAT_RATING_SUCCESS_TYPE,
  CSATAdminAppDisplay
>;
type GetCSATRatingFailureAction = Action<
  GET_CSAT_RATING_FAILURE_TYPE,
  { error: any }
>;

export type CSATRatingAction =
  | UpdateCSATRatingRequestAction
  | UpdateCSATRatingSuccessAction
  | UpdateCSATRatingFailureAction
  | GetCSATRatingRequestAction
  | GetCSATRatingSuccessAction
  | GetCSATRatingFailureAction;

export type CSATRatingState = {
  csatRating: any,
  getCSATRatingLoading: boolean,
  getCSATRatingSuccess: boolean,
  error: any,

  updateCSATRatingLoading: boolean,
  updateCSATRatingSuccess: boolean
};

export const RATING_STATUS = {
  COMPLETE: 'complete',
  IN_COMPLETE: 'incomplete'
}

export const RATING_TYPE = {
  DASHBOARD: 'dashboard',
  ONBOARDING: 'onboarding'
}